import React from 'react';

import { Droppable } from 'react-beautiful-dnd';

import AssignPack from './packs/AssignPack';

export default function AssignPacks({ packs }) {
    return (
        <Droppable droppableId="droppable-1">
            {(provided, snapshot) => {
                return (
                    <div className="tw-space-y-2" ref={provided.innerRef} {...provided.droppableProps}>
                        {(!!packs.length && packs.map((pack, i) => (pack.deleted ? '' : <AssignPack index={i} pack={pack} key={i.toString()} />))) || (
                            <NoPacksFound />
                        )}

                        <div className="d-none">{provided.placeholder}</div>
                    </div>
                );
            }}
        </Droppable>
    );
}

const NoPacksFound = () => {
    return <p className="tw-text-sm tw-text-charcoal-50">{$t('No packs found')}</p>;
};
